import normalizeImage from "@models/Image"

const BlogSlider = ({ title, description, items, image }) => {
  const normalizedSlides = items.map((item) => {
    return {
      title: item.title,
      description: item.description,
    }
  })

  const normalizedData = {
    theme: 'white',
    title,
    description,
    items: normalizedSlides,
    image: normalizeImage(image),
  }

  return normalizedData
}

export default BlogSlider
